var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 228,
    viewBox: "0 0 312 228",
    width: 312,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 94.8656,
    x2: 121.185,
    y1: 1.6182,
    y2: 210.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302d4c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 110.469,
    x2: 184.538,
    y1: 8.41363,
    y2: 196.284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c344ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d666a9"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 99.6324,
    x2: 191.53,
    y1: 37.1415,
    y2: 36.2071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af94ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#936fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 94.4484,
    x2: 186.279,
    y1: 102.775,
    y2: 97.9029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb432"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 101.783,
    x2: 195.22,
    y1: 170.856,
    y2: 163.88
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff659b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff367e"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 242.172,
    x2: 220.061,
    y1: 183.139,
    y2: 147.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#632a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#572357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330f36"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 209.087,
    x2: 208.993,
    y1: 186.338,
    y2: 147.506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#632a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#592459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330f36"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 216.587,
    x2: 215.872,
    y1: 83.682,
    y2: 87.8448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee7400"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 218.272,
    x2: 216.462,
    y1: 82.6168,
    y2: 89.6081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8964f"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 234.575,
    x2: 202.647,
    y1: 144.366,
    y2: 95.9495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f13a75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f471b9"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 232.479,
    x2: 227.322,
    y1: 112.345,
    y2: 120.488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f35a9c",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e02d66",
    stopOpacity: 0.97
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 274.556,
    x2: 223.569,
    y1: 74.4349,
    y2: 92.6442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41438e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2b5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m153.895 227.11c77.262 0 139.895-6.406 139.895-14.309 0-7.902-62.633-14.309-139.895-14.309-77.2618 0-139.895 6.407-139.895 14.309 0 7.903 62.6332 14.309 139.895 14.309z",
    fill: "#dae1e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.4359 9.50053c-.2523-2.21531.4571-4.43251 1.948-6.09001 1.4913-1.65751 3.6215-2.596647 5.8513-2.579227 22.5315.176847 81.6728.640357 97.5548.764947 2.271.0178 4.173 1.72225 4.44 3.97732 3.016 25.49424 19.724 166.73244 22.957 194.06244.143 1.204-.207 2.416-.968 3.36-.762.944-1.873 1.541-3.081 1.656-17 1.616-76.482 7.272-97.7232 9.292-4.2254.402-7.9948-2.654-8.475-6.871-3.7413-32.845-18.5178-162.5759-22.5039-197.57247z",
    fill: "#181233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.6262 5.88485c-.1466-1.28261.2635-2.56635 1.1265-3.52594.8629-.95997 2.0959-1.503758 3.3865-1.493534 18.8456.147684 84.4118.661564 101.2598.793724 2.269.0178 4.172 1.72075 4.44 3.97506 3.025 25.44044 19.761 166.20584 23.005 193.49284.143 1.205-.206 2.417-.968 3.362-.762.944-1.873 1.542-3.081 1.657-17.961 1.708-83.311 7.921-100.929 9.597-2.4449.232-4.6254-1.535-4.9046-3.974-3.1357-27.399-19.9857-174.6213-23.3352-203.88415z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.8334 4.45171c.5636.0046 1.0352.4256 1.1081.98502.253 1.9984.809 6.36677.809 6.36677.3642 3.0747 2.9638 5.3944 6.0619 5.4089 11.5716.0533 38.6526.1783 51.1176.2358 1.687.0077 3.303-.6798 4.468-1.9006 1.164-1.2208 1.775-2.8672 1.687-4.5524 0 0-.27-3.02021-.426-4.76632-.027-.30981.077-.61693.287-.84622.211-.2289.508-.3585.819-.35735 3.499.01611 13.36.06097 13.36.06097 2.025.01649 3.722 1.53561 3.961 3.54628 2.835 23.84434 19.214 161.59744 22.253 187.15444.128 1.074-.183 2.154-.86 2.996-.678.843-1.667 1.376-2.743 1.481-16.642 1.62-79.173 7.704-95.5301 9.296-2.1817.212-4.1334-1.365-4.3826-3.545-2.9447-25.708-19.451-169.7778-22.5951-197.21872-.1304-1.14452.2339-2.2898 1.0045-3.14637.7707-.85657 1.8712-1.3416 3.0253-1.3324 0 0 12.8715.1043 16.5754.1342z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.3894 16.215c-.1809-1.592.3253-3.1855 1.3921-4.381 1.0665-1.1955 2.5927-1.87922 4.1949-1.87984 18.2056-.00672 70.5426-.02583 85.4746-.03131 2.29-.00082 4.218 1.71705 4.479 3.99305 1.12 9.7636 4.004 34.8828 5.332 46.4555.178 1.5471-.299 3.0981-1.314 4.2786-1.016 1.1806-2.478 1.8836-4.034 1.9394-17.481.6265-67.931 2.4346-84.261 3.0199-2.916.1046-5.4215-2.0526-5.7517-4.9519-1.2459-10.9516-4.1599-36.5619-5.5119-48.4424z",
    fill: "#7e64cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.3594 14.9649c-.149-1.2773.2552-2.5575 1.1102-3.5181.8551-.9606 2.0797-1.51021 3.3656-1.51041 16.8688-.00259 70.9608-.01116 86.1628-.01354 2.286-.00031 4.21 1.71025 4.477 3.98035 1.164 9.8851 4.181 35.5268 5.446 46.2777.147 1.2504-.235 2.5052-1.055 3.4609-.82.9556-2.001 1.5249-3.26 1.57-16.568.5939-70.443 2.5248-85.861 3.0774-2.348.0841-4.366-1.6492-4.638-3.9827-1.2185-10.4616-4.4232-37.9721-5.7476-49.3416z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.8931 79.9815c-.1834-1.5622.2944-3.1299 1.3179-4.3241 1.0239-1.1942 2.5004-1.9061 4.072-1.9634 17.526-.6392 67.789-2.4722 84.021-3.0642 2.903-.1059 5.411 2.0136 5.791 4.8942 1.395 10.5942 4.61 34.998 6.103 46.337.204 1.55-.245 3.115-1.239 4.321-.995 1.206-2.446 1.944-4.006 2.039-17.473 1.057-67.911 4.107-84.439 5.107-2.9823.18-5.587-1.999-5.9355-4.966-1.3019-11.077-4.3081-36.6591-5.6854-48.3805z",
    fill: "#b87134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.1317 78.6625c-.1456-1.2491.2376-2.5023 1.0563-3.4566.8191-.9543 1.9996-1.5231 3.2562-1.569 16.6078-.6056 70.7848-2.5814 86.2258-3.1446 2.342-.0854 4.358 1.6374 4.639 3.9635 1.231 10.1937 4.418 36.5752 5.727 47.4122.149 1.233-.218 2.474-1.014 3.428s-1.951 1.537-3.191 1.611c-16.451.984-70.58 4.221-86.196 5.154-2.387.143-4.4695-1.602-4.7464-3.977-1.2339-10.592-4.4499-38.2007-5.7569-49.4215z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.9496 147.287c-.1802-1.552.2922-3.11 1.3049-4.3 1.0122-1.191 2.4735-1.907 4.0345-1.978 17.458-.796 67.783-3.088 84.044-3.829 2.908-.133 5.438 1.972 5.837 4.856 1.416 10.239 4.599 33.266 6.09 44.053.21 1.514-.205 3.049-1.149 4.251s-2.336 1.969-3.857 2.125c-17.183 1.761-67.633 6.932-84.453 8.656-3.066.314-5.815-1.893-6.171-4.954-1.317-11.334-4.3166-37.147-5.6804-48.88z",
    fill: "#bf3868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.9979 145.911c-.1432-1.232.2271-2.469 1.0246-3.419.797-.95 1.9505-1.529 3.1885-1.602 16.42-.962 70.488-4.128 86.079-5.041 2.383-.14 4.461 1.602 4.74 3.972 1.195 10.153 4.221 35.869 5.454 46.346.141 1.2-.205 2.405-.961 3.347s-1.858 1.542-3.059 1.664c-16.052 1.632-69.871 7.104-85.706 8.715-2.451.249-4.648-1.516-4.933-3.963-1.265-10.861-4.5223-38.82-5.8271-50.019z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.607 207.575c.524-.305.27-1.028.252-1.077-.156-.44-.479-1.102-.56-1.582-.113-.674-.041-2.136.088-2.775.547-2.702-2.674-2.082-2.894-.471-.161 1.182.383 1.759.803 2.866.171.454.413 1.294.463 1.774.089.834-.076 1.002.328 1.425.117.123.508.172.686.112.224-.074.592-.129.834-.272z",
    fill: "#f19f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.989 212.027c.381.185 1.851.208 2.416.186 1.595-.057 1.477-.383 2.029-1.605.385-.849.518-1.854 1.623-2.229.996-.338.771-1.201-.042-2.36-.4-.573-1.325-.25-1.78.132-.578.486-.653 1.229-1.16 2.038-.455.728-.761 1.278-1.406 2.145-.703.947-1.959.558-2.083 1.109-.1.446.286.526.403.584z",
    fill: "#54384b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.027 210.363c-.829-.164-1.044-.597-.31-2.023.295-.573.48-1.041.582-2.298.155-1.903-.478-3.326-.412-4.657.105-2.202 4.476-3.509 3.437 2.626-.053.316-.325 1.333-.516 2.592-.086.567-.173 1.925-.173 2.54 0 .223.158.883-.075.999-.748.373-1.605.406-2.533.221z",
    fill: "#f19f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.917 207.667c.45.009.615.181 1.254.146.51-.026 1.828-.586 2.035-.099.228.539.243.828.294 1.612.045.673-.09 1.617-.472 1.611-4.535-.075-4.583.645-6.574.309-.592-.099-1.305-.198-1.637-.906-.322-.688.738-.478 1.426-.746 1.037-.402 1.692-.714 2.399-1.184.777-.515.675-.754 1.275-.743z",
    fill: "#54384b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.723 198.436c-2.872-10.979-10.847-32.954-18.177-44.611-7.33-11.654 11.909-24.955 14.479-5.233.573 4.395-1.227 6.089 1.136 12.054 1.883 4.755 4.063 6.781 5.685 11.701 3.131 9.488 2.622 23.249 2.099 27.811-.328 2.861.082 3.297-2.116 3.142-2.463-.176-1.882-.185-3.106-4.864z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.548 201.355c-1.029-8.602-4.241-39.438-2.771-54.687 1.471-15.247 27.064-15.897 16.09 5.027-7.599 14.491-3.221 18.895-4.264 29.651-1.042 10.756-3.214 13.74-4.199 19.093-.993 5.4-.735 5.281-3.009 5.236-1.533-.027-1.292.325-1.847-4.32z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.889 76.8949c-.978.6501-1.506.0057-2.841 2.2024-.651 1.0704-1.223 2.4439-1.427 3.6515-.14.8268-.358 2.4533.647 2.894.459.1983 2.261.0494 2.612-.1702 1.207-.7565 1.14-1.4921 2.045-1.8435.682-.2631 1.012-.3977 1.618-.8291 1.38-.9795 1.605-3.4417.773-4.8191-.708-1.1712-2.139-1.9362-3.36-1.0694",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.022 91.0909c-.125.0144.103-.3109.154-.4663.097-.2899.187-.5825.274-.8777.279-.9411.59-2.194.642-3.2039.148-2.8579.358-3.9003 1.131-6.0206.182-.5005.82-1.8711 1.365-1.5683.288.1595.348.7633.412 1.1159.189 1.034.354 2.0544.364 3.1285.029 3.3283-.845 6.6801-2.149 9.4872-.231.4973-.479.9916-.764 1.4406-.192.302-.404.5798-.631.8337-.856.9607-1.563.4656-1.57-.9657-.006-1.2936.597-2.1145.892-3.2538",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.536 72.2209c.619-.0179.559-1.0502.091-1.9244-.3-.5609-.605-1.1189-.938-1.6589-1.159-1.8857-2.547-3.6311-3.987-5.3079-.345-.4028-.666-.8265-1.086-1.1576-.109-.0836-.372-.2716-.52-.1582-.265.1999.069.7698.171.9637.449.8533 1.263 1.5455 1.636 2.4346.187.4446-.416 1.0235-.67 1.3099-.624.7011-.717 1.5514.009 2.2675.905.8921 2.071.4147 3.081.9637.835.4565 1.299 2.2915 2.213 2.2676z",
    fill: "#f3b376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.47 134.842c-1.571-14.703 9.131-16.264 9.131-29.744-9.429-1.241-17.22-8.8612-21.369-13.7752-4.149-4.917-8.399-13.68-9.648-17.7646-.742-2.4287-1.22-3.097.965-3.6609 1.979-.5072 1.525-.6743 3.975 3.3118 5.978 9.7356 15.543 17.4304 33.565 15.7715 5.862-.54 9.433-.349 12.596-.2356 5.373.1939 10.177 5.1437 10.688 15.363.318 6.331.234 6.504.261 10.848s-2.775 5.66-4.311 5.738c-1.536.08-3.768-.158-4.253-2.301-.315 2.077-.621 3.798-.346 5.979 0 0 .208 5.428 9.311 7.146 2.722.516 4.967 1.113 6.486 2.683 3.513 3.631 2.152 7.483 4.831 10.159 2.678 2.679 4.215 3.619 7.175 4.821 2.96 1.2.569 5.654-3.846 7.531-4.416 1.877-4.965 2.676-7.985 2.629-3.02-.048-4.112-2.125-6.797-2.969-2.685-.847-5.805-.17-8.015-.824-2.209-.656-2.129-2.145-5.977-2.989s-4.743 1.077-10.15-.937c-5.408-2.017-9.222-3.741-12.242-7.017-3.02-3.279-3.646-6.03-4.045-9.763z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.122 118.133c.711-4.711 1.45-10.064 2.016-14.372.566-4.3056 6.181-4.3116 6.312.03.146 4.824.285 6.975.285 11.015 0 4.828-3.174 5.932-4.669 5.967-2.277.054-4.187-1.029-3.944-2.64z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.411 79.7905c2.373 4.2637-1.371 3.0821.466 8.7779 2.143 6.6415 3.576 11.0453 9.337 15.3176 11.832 8.769 17.195-4.1439 32.133-7.5542 9.06-2.0706 22.842 1.8946 26.005-9.7624 3.183-11.7227-.923-18.3822-5.409-22.3027-6.506-5.6838-17.15-3.3566-24.939 2.7688-8.015 6.3014-8.962 14.6616-15.697 15.9445-3.768.7161-6.688.1223-9.644-1.6947-1.83-1.1249-3.659-2.184-5.141-3.7355-4.886-5.1199-8.625-.4773-7.111 2.2407z",
    fill: "url(#l)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.a15e8b1fe9abdce14edca2bc025fcdb5.svg";
export { ForwardRef as ReactComponent };